<template>
  <v-autocomplete
    :items="list"
    :loading="isLoading"
    :search-input.sync="search"
    :filter="() => true"
    item-text="name"
    item-value="id"
    :label="label"
    v-bind="$attrs"
    v-on="$listeners"
    hide-details="auto"
    :placeholder="placeholder"
    @change="handleChange"
  >
    <template v-if="isMultiple" v-slot:prepend-item>
      <v-list-item>
        <rs-text-field autofocus v-model="search" label="Ara" />
      </v-list-item>
      <v-list-item>
        <rs-action @click="selectVisibleOptions">Tümünü Seç</rs-action>
        <rs-action @click="clearSelectedOptions">Tümünü Kaldır</rs-action>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from "@/core/plugins/debounce";

export default {
  /**
   * @deprecated Not in use anywhere 2023-10-09 Ege
   */
  props: {
    companyId: {
      type: Number,
      required: false,
      default: null,
    },
    companyIds: {
      type: Array,
      required: false,
      default: () => [],
    },
    label: {
      type: String,
      required: false,
      default: "TYA Seçin",
    },
    placeholder: {
      type: String,
      required: false,
      default: "Ara",
    },
    extraParams: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  computed: {
    isMultiple() {
      return (
        this.$attrs.multiple !== undefined && this.$attrs.multiple !== false
      );
    },
    selectedValue() {
      const value = this.$attrs.value;

      if (Array.isArray(value)) {
        return value;
      }

      return value ? [value] : [];
    },
  },
  watch: {
    companyId() {
      this.loadList();
    },
    companyIds() {
      this.loadList();
    },
    search: debounce(function () {
      this.loadList();
    }, 250),
  },
  mounted() {
    this.loadList();
  },
  data() {
    return {
      list: [],
      isLoading: false,
      search: null,
    };
  },
  methods: {
    loadList() {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;

      const params = Object.assign(
        {
          per_page: 1000,
          order_by: "name",
        },
        this.extraParams
      );
      if (this.companyIds.length > 0) {
        params.company_ids = this.companyIds;
      } else if (this.companyId !== null) {
        params.company_id = this.companyId;
      }

      if (this.search) {
        params.query = this.search;
      }

      this.$api
        .query("clusters", { params })
        .then((response) => {
          this.list = response.data.data;
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error("Error loading housing cluster list", error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    emitMultipleSelection(ids) {
      const normalizedIds = ids
        .filter((id) => id !== null && id !== undefined && id !== "")
        .map((id) => Number(id))
        .filter((id) => Number.isInteger(id) && id > 0);
      const uniqueIds = Array.from(new Set(normalizedIds));
      const selectedItems = this.list.filter((item) =>
        uniqueIds.includes(item.id)
      );

      this.$emit("input", uniqueIds);
      this.$emit("change:option", {
        id: uniqueIds,
        items: selectedItems,
      });
    },
    selectVisibleOptions() {
      const visibleIds = this.list.map((item) => item.id);
      this.emitMultipleSelection([...this.selectedValue, ...visibleIds]);
    },
    clearSelectedOptions() {
      this.emitMultipleSelection([]);
    },
    handleChange(selectedId) {
      if (Array.isArray(selectedId)) {
        this.emitMultipleSelection(selectedId);
        return false;
      }

      if (!selectedId) {
        this.$emit("change:option", { id: null, item: null });
        return false;
      }
      let selectedItem;

      for (const index in this.list) {
        if (this.list[index].id === selectedId) {
          selectedItem = Object.assign(this.list[index]);
          break;
        }
      }

      this.$emit("change:option", {
        id: selectedId,
        item: selectedItem,
      });

      this.isLoading = true;
      this.$nextTick(() => {
        this.isLoading = false;
      });

      return false;
    },
    /**
     * Adds a new option to result list.
     * @param  {Object} item Cluster Object
     * @return {Boolean}      True if added, false if already exists
     */
    pushOption(item) {
      for (const index in this.list) {
        if (this.list[index].id === item.id) {
          return false;
        }
      }
      this.list.push(item);

      return true;
    },
  },
};
</script>
